<template>
  <filter-template
    @submit="filter()"
    @clear="clearFilter()"
  >
    <v-container
      class="pa-0"
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          mb-2
        >
          <div
            class="headerSubtitle1"
          >
            {{ $t('app.loans.filter.form.status.title') }}
          </div>
        </v-flex>
        <v-flex>
          <input-select
            v-model="payload.status"
            item-text="text"
            item-value="value"
            :items="status"
            :label="'Selecione'"
            :return-object="false"
            multiple
            clearable
          />
        </v-flex>
        <v-flex
          xs12
          mb-2
        >
          <div
            class="headerSubtitle1"
          >
            {{ $t('app.loans.filter.form.rangeInitialLoansDate') }}
          </div>
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <date-picker
            v-model="payload.dataInicialContratacao"
            :rules="[dateLesserThan(payload.dataInicialContratacao)]"
            :label="$t('support.components.reports.initialDate')"
          />
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <date-picker
            v-model="payload.dataFinalContratacao"
            :rules="[dateGreaterThan(payload.dataFinalContratacao)]"
            :label="$t('support.components.reports.finalDate')"
          />
        </v-flex>
        <v-flex
          xs12
          mb-2
        >
          <div
            class="headerSubtitle1"
          >
            {{ $t('app.loans.filter.form.rangeDefeatedDate') }}
          </div>
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <date-picker
            v-model="payload.dataInicialVencimentoBoleto"
            :rules="[dateLesserThan(payload.dataInicialVencimentoBoleto)]"
            :label="$t('support.components.reports.initialDate')"
          />
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <date-picker
            v-model="payload.dataFinalVencimentoBoleto"
            :rules="[dateGreaterThan(payload.dataFinalVencimentoBoleto)]"
            :label="$t('support.components.reports.finalDate')"
          />
        </v-flex>
        <v-flex xs12>
          <input-text
            v-model="payload.clienteIdSgv"
            :rules="[maxLength(10)]"
            mask="##########"
            clearable
            :label="$t('app.loans.filter.form.pdvClientCode')"
          />
        </v-flex>
        <v-flex xs12>
          <input-text
            v-model="payload.cpfCnpj"
            v-mask="['###.###.###-##', '##.###.###/####-##']"
            :rules="[minLength(11)]"
            clearable
            :label="$t('app.loans.filter.form.document')"
            :return-masked-value="false"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </filter-template>
</template>

<script>
import FilterTemplate from 'Support/components/filter-component/FilterTemplate.vue';
import FilterMixin from 'Support/mixins/FilterMixin';
import RulesMixin from 'Support/mixins/rules-mixin';
import InputText from 'Support/components/inputs/InputText.vue';
import InputSelect from 'Support/components/inputs/InputSelect.vue';
import DatePicker from 'Support/components/pickers/DatePicker.vue';
import { statusLoans as status } from 'App/loans/utils';
import Moment from 'moment';
import { mask } from 'vue-the-mask';
import removeFormatting from 'Support/filters/removeFormatting';

export default {
  name: 'LoansFilter',
  directives: {
    mask,
  },
  components: {
    FilterTemplate,
    InputText,
    InputSelect,
    DatePicker,
  },
  mixins: [FilterMixin, RulesMixin],
  data() {
    return {
      menuInitialDate: false,
      menuFinalDate: false,
      payload: {
        status: [],
        dataInicialContratacao: '',
        dataFinalContratacao: '',
        dataInicialVencimentoBoleto: '',
        dataFinalVencimentoBoleto: '',
        cpfCnpj: '',
        clienteIdSgv: '',
      },
      status,
    };
  },
  created() {
    this.setDates();
  },
  methods: {
    prepareFilter() {
      const preparedPayload = { ...this.payload };
      preparedPayload.status = preparedPayload.status.join(',');
      preparedPayload.cpfCnpj = removeFormatting(preparedPayload.cpfCnpj);
      return preparedPayload;
    },
    setDates() {
      if (!this.payload.dataInicialContratacao) {
        this.payload.dataFinalContratacao = Moment().format('YYYY-MM-DD');
        this.payload.dataInicialContratacao = Moment().subtract(90, 'days').format('YYYY-MM-DD');
      }
    },
  },
};
</script>
